// extracted by mini-css-extract-plugin
export default {"partnership":"Partnership_partnership__w2EEI","title":"Partnership_title__0NdTE","sponsors":"Partnership_sponsors__V227Q"};